// import '../fake-db'
import React from 'react'
import { Provider } from 'react-redux'
import { Router, Switch, Route, BrowserRouter } from 'react-router-dom'
import AppContext from './contexts/AppContext'
import history from 'history.js'
import routes from './RootRoutes'
import store from './redux/Store'
import { GlobalCss, MatxSuspense, MatxTheme, MatxLayout } from 'app/components'
import sessionRoutes from './views/sessions/SessionRoutes'
import AuthGuard from './auth/AuthGuard'
import { AuthProvider } from 'app/contexts/JWTAuthContext'
import { SettingsProvider } from 'app/contexts/SettingsContext'
import { Toaster } from 'react-hot-toast';
import { ApiProvider } from './contexts/ApiContext'
import { LoaderProvider } from './contexts/LoaderContext'
import { ToastProvider } from './contexts/ToastContext'
import { BlockModalProvider } from './contexts/BlockModalContext'
import { ToastifyProvider } from './contexts/ToastifyContext'
import { ToastContainer } from 'react-toastify'

const ResgateCupomPage = React.lazy(() => import('../pages/Anunciantes/ResgateCupomPage'))

const App = () => {
    return (
        <AppContext.Provider value={{ routes }}>
            <Provider store={store}>
                <ApiProvider>
                    <ToastifyProvider>
                        <ToastProvider>
                            <SettingsProvider>
                                <MatxTheme>
                                    <GlobalCss />
                                    <BlockModalProvider>
                                    <LoaderProvider>
                                        <BrowserRouter basename={process.env.PUBLIC_URL}>
                                        <Router history={history}>
                                            <AuthProvider>
                                                <MatxSuspense>
                                                    <Switch>
                                                        {/* AUTHENTICATION PAGES (SIGNIN, SIGNUP ETC.) */}
                                                        {sessionRoutes.map((item, i) => (
                                                            <Route
                                                                key={i}
                                                                path={item.path}
                                                                component={item.component}
                                                            />
                                                        ))}
                                                        <Route
                                                            path="/anunciantes/resgatar/:rc"
                                                            component={ResgateCupomPage}
                                                        />
                                                        {/* AUTH PROTECTED DASHBOARD PAGES */}
                                                        <AuthGuard>
                                                            <MatxLayout />{' '}
                                                            {/* RETURNS <Layout1/> component */}
                                                        </AuthGuard>
                                                    </Switch>
                                                </MatxSuspense>
                                            </AuthProvider>
                                        </Router>
                                        </BrowserRouter>
                                    </LoaderProvider>
                                    </BlockModalProvider>
                                </MatxTheme>
                            </SettingsProvider>
                        </ToastProvider>
                    </ToastifyProvider>
                </ApiProvider>
            </Provider>
            <ToastContainer 
                position='bottom-right'
                theme='colored'
            />
            <Toaster 
                position="top-right"
                reverseOrder={false}
            />
        </AppContext.Provider>
    )
}

export default App
